
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'

import { mapActions } from 'vuex'
import editIcon from 'assets/icons/edit.png'
import chooseIcon from 'assets/icons/icon-choose@3x.png'
import selectedIcon from 'assets/icons/icon-choose-selected@3x.png'

export default {
name: 'NameCard',
components: {
Swipeout,
SwipeoutItem,
SwipeoutButton,
},

props: ['name', 'selected', 'type', 'index'],

data() {
return {
editIcon,
chooseIcon,
selectedIcon,
}
},
methods: {
...mapActions(['fetchUserRealNameByUserId']),
deleteRealName(id) {
const self = this
const req = {
id,
}
this.$http.post('/api/user/deleteRealName', req).then(res => res.json())
.then(() => {
this.fetchUserRealNameByUserId(this.$jwt.userId)
})
.catch((err) => {
self.showToast({
content: err.body.resultInfo,
})
})
},
formatattcard(num) {
if (num.length >= 5 && num.length < 9) {
let lable = ''
for (let j = 0; j < num.length - 3; j += 1) {
lable += '*'
}

num = num.substring(0, 1) + lable + num.substring(num.length - 2, num.length)

return num
} else if (num.length <= 11) {
let lable = ''
for (let j = 0; j < num.length - 5; j += 1) {
lable += '*'
}

num = num.substring(0, 3) + lable + num.substring(num.length - 2, num.length)

return num
} else if (num.length >= 12) {
let lable = ''
for (let j = 0; j < num.length - 7; j += 1) {
lable += '*'
}

num = num.substring(0, 3) + lable + num.substring(num.length - 4, num.length)

return num
}
return num
},
},
}



// WEBPACK FOOTER //
// ./client/components/Common/Card/NameCard.vue